import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import { traducirPagina } from '../librerias/funciones'
import { MDBBtn, MDBCol } from 'mdbreact';
import {
    SaveOutlined,
    MailOutlined,
    PrinterOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
    FilePdfOutlined,
    FileExcelOutlined,
    CloseOutlined

} from '@ant-design/icons';

import { Card, Input, Row, Col, Drawer, Tabs } from 'antd';
import store from "../store";
const { TabPane } = Tabs;

const FichaImpresionGenerico = ({ props, configApp }) => {
    const [hayDocumento, setHayDocumento] = React.useState(false);
    const [escalaPorDefecto, setEscalaPorDefecto] = React.useState(0.50);


    if (!hayDocumento && props.ABRIR_FICHA) {
        setHayDocumento(true);

    } else {
        if (!props.ABRIR_FICHA && hayDocumento) {
            //setDocumento("");
            setEscalaPorDefecto(0.50)
            setHayDocumento(false);
          

        }
    }


    const printDiv = (divName) => {
        //let data = document.getElementsByClassName("containerDocumento");
        let data = document.getElementsByClassName("ContenedorDocumento");

        if (data.length > 0) {

            let myWindow = window.open('', 'my div', 'height=600,width=600');
            //myWindow.document.write('<html><head><title>my div</title>');
            //myWindow.document.write('</head><body >');
            myWindow.document.write(props.DOCUMENTO);
            //myWindow.document.write('</body></html>');
            myWindow.document.close();

            myWindow.onload = function () {
                myWindow.focus();
                myWindow.print();
                myWindow.close();
            };
        }
    }



    return (
        <Drawer
            width={435}
            closable={false}
            onClose={() => {
                props.CERRAR_FICHA(false)
                //props.MODIFICAR_DOCUMENTO("")
            }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ zIndex: '999999999999', color: '#fff' }}>

       


                  
            <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {  props.CERRAR_FICHA(false);  props.MODIFICAR_DOCUMENTO("") }}></CloseOutlined>
                        <div> {props.title}</div>
                    </div>
                </div>



            <div className="ant-drawer-header" style={{ backgroundColor: '#676767', color: '#021323', borderBottom: '0px', borderRadius: '0px', padding: '0px 0px' }}>
                <div className="flex-container">
                    <div style={{ flexGrow: '1', textAlign: 'end', color: '#fff', verticalAlign: 'middle', fontSize: '16px' }}>

                        <button title={traducirPagina("Aumentar")} style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767', marginBottom: '5px', marginRight: '5px' }} onClick={(e) => {
                            let operacion = escalaPorDefecto + 0.01
                            setEscalaPorDefecto(operacion)
                        }}>
                            <ZoomInOutlined style={{ fontSize: '22px' }} />

                        </button>

                        <button title={traducirPagina("Reducir")} style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767' }} onClick={(e) => {
                            let operacion = escalaPorDefecto - 0.01
                            setEscalaPorDefecto(operacion)
                        }}>
                            <ZoomOutOutlined style={{ fontSize: '22px' }} />

                        </button>

                        <button title={traducirPagina("Descargar_csv")} style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767', display:props.VER_CSV ? '':'none' }}  onClick={(e) => {
                            props.DESCARGAR_CSV()
                        }}>
                            <FileExcelOutlined style={{ fontSize: '20px' }} />

                        </button>

                        <button title={traducirPagina("Descargar_pdf")} style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767' }} onClick={(e) => {
                            props.DESCARGAR_DOCUMENTO()
                        }}>
                            <FilePdfOutlined style={{ fontSize: '20px' }} />
                        </button>

                        <button title={traducirPagina("Ver_documento")} style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767', marginRight: '5px' }} onClick={(e) => {
                            printDiv("ContainerDocumento")
                        }}>
                            <PrinterOutlined style={{ fontSize: '22px' }} />
                        </button>

                    </div>

                </div>
            </div>

            <div  style={{ height:"calc(100vh - 95px)" , overflow: 'auto', backgroundColor: '#525659',padding:"10px" }}   >
                {props.DOCUMENTO !== "" ?
                    <div className="ml-2 mr-2 mt-2" id="ContainerDocumento">
                        <div style={{ width: '780px', transform: 'scale(' + escalaPorDefecto + ')', transformOrigin: 'left top 0px', height: '100%' }} dangerouslySetInnerHTML={{ __html: props.DOCUMENTO }} />
                    </div>
                    :
                    null
                }

            </div>
        </Drawer>
    )
}


FichaImpresionGenerico.propTypes = {
    title: PropTypes.string,
    DOCUMENTO: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    DESCARGAR_DOCUMENTO: PropTypes.func,
    DESCARGAR_CSV: PropTypes.func,
    MODIFICAR_DOCUMENTO: PropTypes.func,
    VER_CSV:PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp
    };
}

export default connect(mapStateToProps)(FichaImpresionGenerico);